import { render, staticRenderFns } from "./CompTermsOfUse.vue?vue&type=template&id=539dde9c"
import script from "./CompTermsOfUse.vue?vue&type=script&lang=js"
export * from "./CompTermsOfUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports